module.exports = __webpack_public_path__ + "static/04-287f58130cbbb537a100781d48fa53a1.jpg";